import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import { isNil } from 'ramda'

class TicketDeliverableData extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> TicketDeliverableData constructor -', init)
    if (isNil(init)) return undefined
    this._description = init.description
    this._display_name = init.display_name
    this._group = init.group
    this._group_position = init.group_position
    this._name = init.name
    this._count = init.count
  }

  static shape = {
    id: PropTypes.string.isRequired,
    description: PropTypes.string,
    display_name: PropTypes.string,
    group: PropTypes.string,
    group_position: PropTypes.number,
    name: PropTypes.string,
    count: PropTypes.number
  }

  get description() {
    return this._description
  }

  get display_name() {
    return this._display_name
  }

  get group() {
    return this._group
  }

  get group_position() {
    return this._group_position
  }

  get name() {
    return this._name
  }

  get count() {
    return this._count
  }
}

export default TicketDeliverableData
